import { render, staticRenderFns } from "./ApiQuery.vue?vue&type=template&id=972bef42&"
import script from "./ApiQuery.vue?vue&type=script&lang=js&"
export * from "./ApiQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports